/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Configuration/ChangeUiTheme';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangeUiTheme(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangeUiTheme(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getEditions(): Observable<EditionListDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEditions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEditions(<any>response_);
                        } catch (e) {
                            return <Observable<EditionListDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EditionListDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEditions(response: HttpResponseBase): Observable<EditionListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EditionListDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EditionListDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditionForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEditionForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEditionForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetEditionForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetEditionForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetEditionForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetEditionForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateEdition(body: CreateOrUpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Edition/CreateOrUpdateEdition';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateEdition(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateEdition(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Edition/DeleteEdition?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteEdition(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteEdition(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedEditionId (optional)
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditionComboboxItems?';
        if (selectedEditionId === null) throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined) url_ += 'selectedEditionId=' + encodeURIComponent('' + selectedEditionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEditionComboboxItems(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEditionComboboxItems(<any>response_);
                        } catch (e) {
                            return <Observable<ComboboxItemDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ComboboxItemDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ComboboxItemDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ComboboxItemDto[]>([]);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/GetAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllSettings(<any>response_);
                        } catch (e) {
                            return <Observable<HostSettingsEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<HostSettingsEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = HostSettingsEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<HostSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/UpdateAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAllSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAllSettings(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/SendTestEmail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendTestEmail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendTestEmail(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param filter (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getTenants(
        filter: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<TenantListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenants?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTenants(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTenants(<any>response_);
                        } catch (e) {
                            return <Observable<TenantListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTenants(response: HttpResponseBase): Observable<TenantListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(<any>response_);
                        } catch (e) {
                            return <Observable<TenantDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantFeaturesForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTenantFeaturesForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTenantFeaturesForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetTenantFeaturesForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetTenantFeaturesForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetTenantFeaturesForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetTenantFeaturesForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenantFeatures';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTenantFeatures(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTenantFeatures(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/ResetTenantSpecificFeatures';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetTenantSpecificFeatures(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetTenantSpecificFeatures(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Get?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGet(<any>response_);
                        } catch (e) {
                            return <Observable<TenantDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param keyword (optional)
     * @param isActive (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(
        keyword: string | undefined,
        isActive: boolean | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetAll?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAll(<any>response_);
                        } catch (e) {
                            return <Observable<TenantDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(<any>response_);
                        } catch (e) {
                            return <Observable<TenantDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + '/api/services/app/TenantDashboard/GetMemberActivity';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMemberActivity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMemberActivity(<any>response_);
                        } catch (e) {
                            return <Observable<GetMemberActivityOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetMemberActivityOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetMemberActivityOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetMemberActivityOutput>(<any>null);
    }
}

export class AzureStorageSettingsEditDto implements IAzureStorageSettingsEditDto {
    connectionString: string | undefined;

    constructor(data?: IAzureStorageSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data['connectionString'];
        }
    }

    static fromJS(data: any): AzureStorageSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AzureStorageSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['connectionString'] = this.connectionString;
        return data;
    }

    clone(): AzureStorageSettingsEditDto {
        const json = this.toJSON();
        let result = new AzureStorageSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IAzureStorageSettingsEditDto {
    connectionString: string | undefined;
}

export class CacheDto implements ICacheDto {
    name: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }

    clone(): CacheDto {
        const json = this.toJSON();
        let result = new CacheDto();
        result.init(json);
        return result;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CacheDtoListResultDto implements ICacheDtoListResultDto {
    items: CacheDto[] | undefined;

    constructor(data?: ICacheDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CacheDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CacheDtoListResultDto {
        const json = this.toJSON();
        let result = new CacheDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ICacheDtoListResultDto {
    items: CacheDto[] | undefined;
}

export class CarrierFinderProxyDto implements ICarrierFinderProxyDto {
    url: string | undefined;

    constructor(data?: ICarrierFinderProxyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data['url'];
        }
    }

    static fromJS(data: any): CarrierFinderProxyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierFinderProxyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['url'] = this.url;
        return data;
    }

    clone(): CarrierFinderProxyDto {
        const json = this.toJSON();
        let result = new CarrierFinderProxyDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierFinderProxyDto {
    url: string | undefined;
}

export class CarrierFinderProxyOutputDto implements ICarrierFinderProxyOutputDto {
    content: string | undefined;

    constructor(data?: ICarrierFinderProxyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data['content'];
        }
    }

    static fromJS(data: any): CarrierFinderProxyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierFinderProxyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['content'] = this.content;
        return data;
    }

    clone(): CarrierFinderProxyOutputDto {
        const json = this.toJSON();
        let result = new CarrierFinderProxyOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICarrierFinderProxyOutputDto {
    content: string | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data['theme'];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['theme'] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
            this.displayText = _data['displayText'];
            this.isSelected = _data['isSelected'];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        data['displayText'] = this.displayText;
        data['isSelected'] = this.isSelected;
        return data;
    }

    clone(): ComboboxItemDto {
        const json = this.toJSON();
        let result = new ComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class CommissionEstimateDisclaimerEditDto implements ICommissionEstimateDisclaimerEditDto {
    commissionEstimateDisc: string | undefined;

    constructor(data?: ICommissionEstimateDisclaimerEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionEstimateDisc = _data['commissionEstimateDisc'];
        }
    }

    static fromJS(data: any): CommissionEstimateDisclaimerEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionEstimateDisclaimerEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionEstimateDisc'] = this.commissionEstimateDisc;
        return data;
    }

    clone(): CommissionEstimateDisclaimerEditDto {
        const json = this.toJSON();
        let result = new CommissionEstimateDisclaimerEditDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionEstimateDisclaimerEditDto {
    commissionEstimateDisc: string | undefined;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionEditDto.fromJS(_data['edition']) : new EditionEditDto();
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateEditionDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateEditionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.adminEmailAddress = _data['adminEmailAddress'];
            this.connectionString = _data['connectionString'];
            this.isActive = _data['isActive'];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['adminEmailAddress'] = this.adminEmailAddress;
        data['connectionString'] = this.connectionString;
        data['isActive'] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class EditionEditDto implements IEditionEditDto {
    id: number | undefined;
    displayName: string;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        return data;
    }

    clone(): EditionEditDto {
        const json = this.toJSON();
        let result = new EditionEditDto();
        result.init(json);
        return result;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
}

export class EditionListDto implements IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): EditionListDto {
        const json = this.toJSON();
        let result = new EditionListDto();
        result.init(json);
        return result;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;
    id: number;
}

export class EditionListDtoListResultDto implements IEditionListDtoListResultDto {
    items: EditionListDto[] | undefined;

    constructor(data?: IEditionListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): EditionListDtoListResultDto {
        const json = this.toJSON();
        let result = new EditionListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IEditionListDtoListResultDto {
    items: EditionListDto[] | undefined;
}

export class EmailDefaultsDto implements IEmailDefaultsDto {
    monthlyCustomerChurnReportVariance: number;
    monthlyCustomerRevenueIncreaseVariance: number;

    constructor(data?: IEmailDefaultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyCustomerChurnReportVariance = _data['monthlyCustomerChurnReportVariance'];
            this.monthlyCustomerRevenueIncreaseVariance = _data['monthlyCustomerRevenueIncreaseVariance'];
        }
    }

    static fromJS(data: any): EmailDefaultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDefaultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['monthlyCustomerChurnReportVariance'] = this.monthlyCustomerChurnReportVariance;
        data['monthlyCustomerRevenueIncreaseVariance'] = this.monthlyCustomerRevenueIncreaseVariance;
        return data;
    }

    clone(): EmailDefaultsDto {
        const json = this.toJSON();
        let result = new EmailDefaultsDto();
        result.init(json);
        return result;
    }
}

export interface IEmailDefaultsDto {
    monthlyCustomerChurnReportVariance: number;
    monthlyCustomerRevenueIncreaseVariance: number;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data['defaultFromAddress'];
            this.defaultFromDisplayName = _data['defaultFromDisplayName'];
            this.smtpHost = _data['smtpHost'];
            this.smtpPort = _data['smtpPort'];
            this.smtpUserName = _data['smtpUserName'];
            this.smtpPassword = _data['smtpPassword'];
            this.smtpDomain = _data['smtpDomain'];
            this.smtpEnableSsl = _data['smtpEnableSsl'];
            this.smtpUseDefaultCredentials = _data['smtpUseDefaultCredentials'];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['defaultFromAddress'] = this.defaultFromAddress;
        data['defaultFromDisplayName'] = this.defaultFromDisplayName;
        data['smtpHost'] = this.smtpHost;
        data['smtpPort'] = this.smtpPort;
        data['smtpUserName'] = this.smtpUserName;
        data['smtpPassword'] = this.smtpPassword;
        data['smtpDomain'] = this.smtpDomain;
        data['smtpEnableSsl'] = this.smtpEnableSsl;
        data['smtpUseDefaultCredentials'] = this.smtpUseDefaultCredentials;
        return data;
    }

    clone(): EmailSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EmailTemplateFromAddressSettingsEditDto implements IEmailTemplateFromAddressSettingsEditDto {
    quoteProvider: string | undefined;
    quotePartner: string | undefined;
    order: string | undefined;
    ticket: string | undefined;

    constructor(data?: IEmailTemplateFromAddressSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteProvider = _data['quoteProvider'];
            this.quotePartner = _data['quotePartner'];
            this.order = _data['order'];
            this.ticket = _data['ticket'];
        }
    }

    static fromJS(data: any): EmailTemplateFromAddressSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateFromAddressSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteProvider'] = this.quoteProvider;
        data['quotePartner'] = this.quotePartner;
        data['order'] = this.order;
        data['ticket'] = this.ticket;
        return data;
    }

    clone(): EmailTemplateFromAddressSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailTemplateFromAddressSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplateFromAddressSettingsEditDto {
    quoteProvider: string | undefined;
    quotePartner: string | undefined;
    order: string | undefined;
    ticket: string | undefined;
}

export class EmailTemplateSettingsEditDto implements IEmailTemplateSettingsEditDto {
    quoteProvider: string | undefined;
    quotePartner: string | undefined;
    activity: string | undefined;
    milestone: string | undefined;
    orderStatus: string | undefined;
    newOrder: string | undefined;
    partnerDailyOrderSummary: string | undefined;
    ticketConfirmation: string | undefined;
    order: string | undefined;
    ticket: string | undefined;
    ticketNotifications: string | undefined;

    constructor(data?: IEmailTemplateSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteProvider = _data['quoteProvider'];
            this.quotePartner = _data['quotePartner'];
            this.activity = _data['activity'];
            this.milestone = _data['milestone'];
            this.orderStatus = _data['orderStatus'];
            this.newOrder = _data['newOrder'];
            this.partnerDailyOrderSummary = _data['partnerDailyOrderSummary'];
            this.ticketConfirmation = _data['ticketConfirmation'];
            this.order = _data['order'];
            this.ticket = _data['ticket'];
            this.ticketNotifications = _data['ticketNotifications'];
        }
    }

    static fromJS(data: any): EmailTemplateSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteProvider'] = this.quoteProvider;
        data['quotePartner'] = this.quotePartner;
        data['activity'] = this.activity;
        data['milestone'] = this.milestone;
        data['orderStatus'] = this.orderStatus;
        data['newOrder'] = this.newOrder;
        data['partnerDailyOrderSummary'] = this.partnerDailyOrderSummary;
        data['ticketConfirmation'] = this.ticketConfirmation;
        data['order'] = this.order;
        data['ticket'] = this.ticket;
        data['ticketNotifications'] = this.ticketNotifications;
        return data;
    }

    clone(): EmailTemplateSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailTemplateSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplateSettingsEditDto {
    quoteProvider: string | undefined;
    quotePartner: string | undefined;
    activity: string | undefined;
    milestone: string | undefined;
    orderStatus: string | undefined;
    newOrder: string | undefined;
    partnerDailyOrderSummary: string | undefined;
    ticketConfirmation: string | undefined;
    order: string | undefined;
    ticket: string | undefined;
    ticketNotifications: string | undefined;
}

export class EmailUnsubscribeSettingsEditDto implements IEmailUnsubscribeSettingsEditDto {
    newOrderSubmitted: string | undefined;
    partnerProposal: string | undefined;
    providerPricingRequest: string | undefined;
    pricingRequestSubmitted: string | undefined;
    orderProvisioned: string | undefined;
    activityReminders: string | undefined;
    milestone: string | undefined;
    orderStatus: string | undefined;
    newOrder: string | undefined;
    partnerDailyOrderSummary: string | undefined;
    ticketConfirmation: string | undefined;
    order: string | undefined;
    ticket: string | undefined;
    ticketNotifications: string | undefined;
    commissionCreditSummary: string | undefined;
    lostCustomerSummary: string | undefined;
    openCommissionsSummary: string | undefined;
    newCommissionsSummary: string | undefined;
    contractRenewalSummary: string | undefined;
    monthlyChurnReport: string | undefined;

    constructor(data?: IEmailUnsubscribeSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOrderSubmitted = _data['newOrderSubmitted'];
            this.partnerProposal = _data['partnerProposal'];
            this.providerPricingRequest = _data['providerPricingRequest'];
            this.pricingRequestSubmitted = _data['pricingRequestSubmitted'];
            this.orderProvisioned = _data['orderProvisioned'];
            this.activityReminders = _data['activityReminders'];
            this.milestone = _data['milestone'];
            this.orderStatus = _data['orderStatus'];
            this.newOrder = _data['newOrder'];
            this.partnerDailyOrderSummary = _data['partnerDailyOrderSummary'];
            this.ticketConfirmation = _data['ticketConfirmation'];
            this.order = _data['order'];
            this.ticket = _data['ticket'];
            this.ticketNotifications = _data['ticketNotifications'];
            this.commissionCreditSummary = _data['commissionCreditSummary'];
            this.lostCustomerSummary = _data['lostCustomerSummary'];
            this.openCommissionsSummary = _data['openCommissionsSummary'];
            this.newCommissionsSummary = _data['newCommissionsSummary'];
            this.contractRenewalSummary = _data['contractRenewalSummary'];
            this.monthlyChurnReport = _data['monthlyChurnReport'];
        }
    }

    static fromJS(data: any): EmailUnsubscribeSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailUnsubscribeSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['newOrderSubmitted'] = this.newOrderSubmitted;
        data['partnerProposal'] = this.partnerProposal;
        data['providerPricingRequest'] = this.providerPricingRequest;
        data['pricingRequestSubmitted'] = this.pricingRequestSubmitted;
        data['orderProvisioned'] = this.orderProvisioned;
        data['activityReminders'] = this.activityReminders;
        data['milestone'] = this.milestone;
        data['orderStatus'] = this.orderStatus;
        data['newOrder'] = this.newOrder;
        data['partnerDailyOrderSummary'] = this.partnerDailyOrderSummary;
        data['ticketConfirmation'] = this.ticketConfirmation;
        data['order'] = this.order;
        data['ticket'] = this.ticket;
        data['ticketNotifications'] = this.ticketNotifications;
        data['commissionCreditSummary'] = this.commissionCreditSummary;
        data['lostCustomerSummary'] = this.lostCustomerSummary;
        data['openCommissionsSummary'] = this.openCommissionsSummary;
        data['newCommissionsSummary'] = this.newCommissionsSummary;
        data['contractRenewalSummary'] = this.contractRenewalSummary;
        data['monthlyChurnReport'] = this.monthlyChurnReport;
        return data;
    }

    clone(): EmailUnsubscribeSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailUnsubscribeSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailUnsubscribeSettingsEditDto {
    newOrderSubmitted: string | undefined;
    partnerProposal: string | undefined;
    providerPricingRequest: string | undefined;
    pricingRequestSubmitted: string | undefined;
    orderProvisioned: string | undefined;
    activityReminders: string | undefined;
    milestone: string | undefined;
    orderStatus: string | undefined;
    newOrder: string | undefined;
    partnerDailyOrderSummary: string | undefined;
    ticketConfirmation: string | undefined;
    order: string | undefined;
    ticket: string | undefined;
    ticketNotifications: string | undefined;
    commissionCreditSummary: string | undefined;
    lostCustomerSummary: string | undefined;
    openCommissionsSummary: string | undefined;
    newCommissionsSummary: string | undefined;
    contractRenewalSummary: string | undefined;
    monthlyChurnReport: string | undefined;
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id: number;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.defaultValue = _data['defaultValue'];
            this.inputType = _data['inputType'] ? IInputType.fromJS(_data['inputType']) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['defaultValue'] = this.defaultValue;
        data['inputType'] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }

    clone(): FlatFeatureDto {
        const json = this.toJSON();
        let result = new FlatFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data['timezone'];
            this.timezoneForComparison = _data['timezoneForComparison'];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['timezone'] = this.timezone;
        data['timezoneForComparison'] = this.timezoneForComparison;
        return data;
    }

    clone(): GeneralSettingsEditDto {
        const json = this.toJSON();
        let result = new GeneralSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GetEditionForEditOutput implements IGetEditionForEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionEditDto.fromJS(_data['edition']) : <any>undefined;
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data['features'])) {
                this.features = [] as any;
                for (let item of _data['features']) this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data['features'] = [];
            for (let item of this.features) data['features'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetEditionForEditOutput {
        const json = this.toJSON();
        let result = new GetEditionForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetEditionForEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    totalMembers: number[] | undefined;
    newMembers: number[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['totalMembers'])) {
                this.totalMembers = [] as any;
                for (let item of _data['totalMembers']) this.totalMembers.push(item);
            }
            if (Array.isArray(_data['newMembers'])) {
                this.newMembers = [] as any;
                for (let item of _data['newMembers']) this.newMembers.push(item);
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totalMembers)) {
            data['totalMembers'] = [];
            for (let item of this.totalMembers) data['totalMembers'].push(item);
        }
        if (Array.isArray(this.newMembers)) {
            data['newMembers'] = [];
            for (let item of this.newMembers) data['newMembers'].push(item);
        }
        return data;
    }

    clone(): GetMemberActivityOutput {
        const json = this.toJSON();
        let result = new GetMemberActivityOutput();
        result.init(json);
        return result;
    }
}

export interface IGetMemberActivityOutput {
    totalMembers: number[] | undefined;
    newMembers: number[] | undefined;
}

export class GetTenantFeaturesForEditOutput implements IGetTenantFeaturesForEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data['features'])) {
                this.features = [] as any;
                for (let item of _data['features']) this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data['features'] = [];
            for (let item of this.features) data['features'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetTenantFeaturesForEditOutput {
        const json = this.toJSON();
        let result = new GetTenantFeaturesForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTenantFeaturesForEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data['general'] ? GeneralSettingsEditDto.fromJS(_data['general']) : new GeneralSettingsEditDto();
            this.userManagement = _data['userManagement']
                ? HostUserManagementSettingsEditDto.fromJS(_data['userManagement'])
                : new HostUserManagementSettingsEditDto();
            this.email = _data['email'] ? EmailSettingsEditDto.fromJS(_data['email']) : new EmailSettingsEditDto();
            this.tenantManagement = _data['tenantManagement']
                ? TenantManagementSettingsEditDto.fromJS(_data['tenantManagement'])
                : new TenantManagementSettingsEditDto();
            this.security = _data['security'] ? SecuritySettingsEditDto.fromJS(_data['security']) : new SecuritySettingsEditDto();
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['general'] = this.general ? this.general.toJSON() : <any>undefined;
        data['userManagement'] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data['email'] = this.email ? this.email.toJSON() : <any>undefined;
        data['tenantManagement'] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data['security'] = this.security ? this.security.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostSettingsEditDto {
        const json = this.toJSON();
        let result = new HostSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data['isEmailConfirmationRequiredForLogin'];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEmailConfirmationRequiredForLogin'] = this.isEmailConfirmationRequiredForLogin;
        return data;
    }

    clone(): HostUserManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new HostUserManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
}

export class IInputType implements IIInputType {
    readonly name: string | undefined;
    readonly attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (_data['attributes']) {
                (<any>this).attributes = {} as any;
                for (let key in _data['attributes']) {
                    if (_data['attributes'].hasOwnProperty(key)) (<any>this).attributes[key] = _data['attributes'][key];
                }
            }
            this.validator = _data['validator'] ? IValueValidator.fromJS(_data['validator']) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (this.attributes) {
            data['attributes'] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key)) data['attributes'][key] = this.attributes[key];
            }
        }
        data['validator'] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }

    clone(): IInputType {
        const json = this.toJSON();
        let result = new IInputType();
        result.init(json);
        return result;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
    readonly name: string | undefined;
    readonly attributes: { [key: string]: any } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (_data['attributes']) {
                (<any>this).attributes = {} as any;
                for (let key in _data['attributes']) {
                    if (_data['attributes'].hasOwnProperty(key)) (<any>this).attributes[key] = _data['attributes'][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (this.attributes) {
            data['attributes'] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key)) data['attributes'][key] = this.attributes[key];
            }
        }
        return data;
    }

    clone(): IValueValidator {
        const json = this.toJSON();
        let result = new IValueValidator();
        result.init(json);
        return result;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
}

export class IntegrationSettingsEditDto implements IIntegrationSettingsEditDto {
    carrierFinderSiteKey: string | undefined;
    postNotificationEndPoint: string | undefined;

    constructor(data?: IIntegrationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierFinderSiteKey = _data['carrierFinderSiteKey'];
            this.postNotificationEndPoint = _data['postNotificationEndPoint'];
        }
    }

    static fromJS(data: any): IntegrationSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['carrierFinderSiteKey'] = this.carrierFinderSiteKey;
        data['postNotificationEndPoint'] = this.postNotificationEndPoint;
        return data;
    }

    clone(): IntegrationSettingsEditDto {
        const json = this.toJSON();
        let result = new IntegrationSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IIntegrationSettingsEditDto {
    carrierFinderSiteKey: string | undefined;
    postNotificationEndPoint: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data['isModuleEnabled'];
            this.isEnabled = _data['isEnabled'];
            this.domain = _data['domain'];
            this.userName = _data['userName'];
            this.password = _data['password'];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isModuleEnabled'] = this.isModuleEnabled;
        data['isEnabled'] = this.isEnabled;
        data['domain'] = this.domain;
        data['userName'] = this.userName;
        data['password'] = this.password;
        return data;
    }

    clone(): LdapSettingsEditDto {
        const json = this.toJSON();
        let result = new LdapSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['value'] = this.value;
        return data;
    }

    clone(): NameValueDto {
        const json = this.toJSON();
        let result = new NameValueDto();
        result.init(json);
        return result;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class OrderManagementSettingsEditDto implements IOrderManagementSettingsEditDto {
    orderLocationCount: string | undefined;

    constructor(data?: IOrderManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLocationCount = _data['orderLocationCount'];
        }
    }

    static fromJS(data: any): OrderManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderLocationCount'] = this.orderLocationCount;
        return data;
    }

    clone(): OrderManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new OrderManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderManagementSettingsEditDto {
    orderLocationCount: string | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    minLength: number;
    maxLength: number;
    useNumbers: boolean;
    useUpperCaseLetters: boolean;
    useLowerCaseLetters: boolean;
    usePunctuations: boolean;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minLength = _data['minLength'];
            this.maxLength = _data['maxLength'];
            this.useNumbers = _data['useNumbers'];
            this.useUpperCaseLetters = _data['useUpperCaseLetters'];
            this.useLowerCaseLetters = _data['useLowerCaseLetters'];
            this.usePunctuations = _data['usePunctuations'];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['minLength'] = this.minLength;
        data['maxLength'] = this.maxLength;
        data['useNumbers'] = this.useNumbers;
        data['useUpperCaseLetters'] = this.useUpperCaseLetters;
        data['useLowerCaseLetters'] = this.useLowerCaseLetters;
        data['usePunctuations'] = this.usePunctuations;
        return data;
    }

    clone(): PasswordComplexitySetting {
        const json = this.toJSON();
        let result = new PasswordComplexitySetting();
        result.init(json);
        return result;
    }
}

export interface IPasswordComplexitySetting {
    minLength: number;
    maxLength: number;
    useNumbers: boolean;
    useUpperCaseLetters: boolean;
    useLowerCaseLetters: boolean;
    usePunctuations: boolean;
}

export class QuoteManagementSettingsEditDto implements IQuoteManagementSettingsEditDto {
    locationProductCount: string | undefined;

    constructor(data?: IQuoteManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationProductCount = _data['locationProductCount'];
        }
    }

    static fromJS(data: any): QuoteManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['locationProductCount'] = this.locationProductCount;
        return data;
    }

    clone(): QuoteManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new QuoteManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteManagementSettingsEditDto {
    locationProductCount: string | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
    externalApiTokenValidation: TokenManagementSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useDefaultPasswordComplexitySettings = _data['useDefaultPasswordComplexitySettings'];
            this.passwordComplexity = _data['passwordComplexity']
                ? PasswordComplexitySetting.fromJS(_data['passwordComplexity'])
                : <any>undefined;
            this.defaultPasswordComplexity = _data['defaultPasswordComplexity']
                ? PasswordComplexitySetting.fromJS(_data['defaultPasswordComplexity'])
                : <any>undefined;
            this.userLockOut = _data['userLockOut'] ? UserLockOutSettingsEditDto.fromJS(_data['userLockOut']) : <any>undefined;
            this.twoFactorLogin = _data['twoFactorLogin'] ? TwoFactorLoginSettingsEditDto.fromJS(_data['twoFactorLogin']) : <any>undefined;
            this.externalApiTokenValidation = _data['externalApiTokenValidation']
                ? TokenManagementSettingsEditDto.fromJS(_data['externalApiTokenValidation'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['useDefaultPasswordComplexitySettings'] = this.useDefaultPasswordComplexitySettings;
        data['passwordComplexity'] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data['defaultPasswordComplexity'] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data['userLockOut'] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data['twoFactorLogin'] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        data['externalApiTokenValidation'] = this.externalApiTokenValidation ? this.externalApiTokenValidation.toJSON() : <any>undefined;
        return data;
    }

    clone(): SecuritySettingsEditDto {
        const json = this.toJSON();
        let result = new SecuritySettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
    externalApiTokenValidation: TokenManagementSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailAddress'] = this.emailAddress;
        return data;
    }

    clone(): SendTestEmailInput {
        const json = this.toJSON();
        let result = new SendTestEmailInput();
        result.init(json);
        return result;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export interface IStringEntityDto {
    id: string | undefined;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.isActive = _data['isActive'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['isActive'] = this.isActive;
        data['id'] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.editionDisplayName = _data['editionDisplayName'];
            this.connectionString = _data['connectionString'];
            this.isActive = _data['isActive'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['editionDisplayName'] = this.editionDisplayName;
        data['connectionString'] = this.connectionString;
        data['isActive'] = this.isActive;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TenantListDto {
        const json = this.toJSON();
        let result = new TenantListDto();
        result.init(json);
        return result;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class TenantListDtoPagedResultDto implements ITenantListDtoPagedResultDto {
    totalCount: number;
    items: TenantListDto[] | undefined;

    constructor(data?: ITenantListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantListDtoPagedResultDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data['allowSelfRegistration'];
            this.isNewRegisteredTenantActiveByDefault = _data['isNewRegisteredTenantActiveByDefault'];
            this.useCaptchaOnRegistration = _data['useCaptchaOnRegistration'];
            this.defaultEditionId = _data['defaultEditionId'];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['allowSelfRegistration'] = this.allowSelfRegistration;
        data['isNewRegisteredTenantActiveByDefault'] = this.isNewRegisteredTenantActiveByDefault;
        data['useCaptchaOnRegistration'] = this.useCaptchaOnRegistration;
        data['defaultEditionId'] = this.defaultEditionId;
        return data;
    }

    clone(): TenantManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export interface ITenantSettingsEditDto {
    title: string | undefined;
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    quoteManagement: QuoteManagementSettingsEditDto;
    orderManagement: OrderManagementSettingsEditDto;
    emailTemplateManagement: EmailTemplateSettingsEditDto;
    emailTemplateFromAddressManagement: EmailTemplateFromAddressSettingsEditDto;
    emailUnsubscribeGroup: EmailUnsubscribeSettingsEditDto;
    azureStorage: AzureStorageSettingsEditDto;
    commissionEstimateDisclaimer: CommissionEstimateDisclaimerEditDto;
    tokenManagement: TokenManagementSettingsEditDto;
    integrationManagement: IntegrationSettingsEditDto;
    emailDefaults: EmailDefaultsDto;
    googleMapsApiKey: string | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    allowSelfExternalRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isNewRegisteredExternalUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data['allowSelfRegistration'];
            this.allowSelfExternalRegistration = _data['allowSelfExternalRegistration'];
            this.isNewRegisteredUserActiveByDefault = _data['isNewRegisteredUserActiveByDefault'];
            this.isNewRegisteredExternalUserActiveByDefault = _data['isNewRegisteredExternalUserActiveByDefault'];
            this.isEmailConfirmationRequiredForLogin = _data['isEmailConfirmationRequiredForLogin'];
            this.useCaptchaOnRegistration = _data['useCaptchaOnRegistration'];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['allowSelfRegistration'] = this.allowSelfRegistration;
        data['allowSelfExternalRegistration'] = this.allowSelfExternalRegistration;
        data['isNewRegisteredUserActiveByDefault'] = this.isNewRegisteredUserActiveByDefault;
        data['isNewRegisteredExternalUserActiveByDefault'] = this.isNewRegisteredExternalUserActiveByDefault;
        data['isEmailConfirmationRequiredForLogin'] = this.isEmailConfirmationRequiredForLogin;
        data['useCaptchaOnRegistration'] = this.useCaptchaOnRegistration;
        return data;
    }

    clone(): TenantUserManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantUserManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    allowSelfExternalRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isNewRegisteredExternalUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
}

export class TokenManagementSettingsEditDto implements ITokenManagementSettingsEditDto {
    externalApiTokenValidation: string | undefined;

    constructor(data?: ITokenManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalApiTokenValidation = _data['externalApiTokenValidation'];
        }
    }

    static fromJS(data: any): TokenManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['externalApiTokenValidation'] = this.externalApiTokenValidation;
        return data;
    }

    clone(): TokenManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new TokenManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITokenManagementSettingsEditDto {
    externalApiTokenValidation: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data['isEnabledForApplication'];
            this.isEnabled = _data['isEnabled'];
            this.isEmailProviderEnabled = _data['isEmailProviderEnabled'];
            this.isSmsProviderEnabled = _data['isSmsProviderEnabled'];
            this.isRememberBrowserEnabled = _data['isRememberBrowserEnabled'];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEnabledForApplication'] = this.isEnabledForApplication;
        data['isEnabled'] = this.isEnabled;
        data['isEmailProviderEnabled'] = this.isEmailProviderEnabled;
        data['isSmsProviderEnabled'] = this.isSmsProviderEnabled;
        data['isRememberBrowserEnabled'] = this.isRememberBrowserEnabled;
        return data;
    }

    clone(): TwoFactorLoginSettingsEditDto {
        const json = this.toJSON();
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateTenantFeaturesInput {
        const json = this.toJSON();
        let result = new UpdateTenantFeaturesInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data['isEnabled'];
            this.maxFailedAccessAttemptsBeforeLockout = _data['maxFailedAccessAttemptsBeforeLockout'];
            this.defaultAccountLockoutSeconds = _data['defaultAccountLockoutSeconds'];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEnabled'] = this.isEnabled;
        data['maxFailedAccessAttemptsBeforeLockout'] = this.maxFailedAccessAttemptsBeforeLockout;
        data['defaultAccountLockoutSeconds'] = this.defaultAccountLockoutSeconds;
        return data;
    }

    clone(): UserLockOutSettingsEditDto {
        const json = this.toJSON();
        let result = new UserLockOutSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}
